import axios from "axios";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { LtlBidpackViewModel } from "../../../ViewModel/LtlBidpackViewModel";
import { parseDate } from "../../ParseDate";
import { GetQueryString } from "../../../../Utils/GetQueryString";
import { combinedUrls } from "../../../../URL/functions";
import { projectUrls } from "../../../../URL/ApplicationUrls";

export async function getSpdrBidPack(
  ltlPipeline: LtlPipelineViewModel,
  startDateDisplay: string | undefined
) {
  const data = {
    supplierGsdb: ltlPipeline.SupplierGsdb,
    plantGsdb: ltlPipeline.PlantGsdb,
    projectStartDateString: startDateDisplay,
    isJitKanban: ltlPipeline.JitKanban,
  };

  const baseUrl = combinedUrls(projectUrls.base.apiUrl, "/GetSpdrBidPack");
  const url = `${baseUrl}?${GetQueryString(data)}`;
  const response = await axios.get(url);

  const json = response.data;
  json.RateAgreementStartDate = parseDate(json.RateAgreementStartDate);
  json.StartDate = parseDate(json.StartDate);
  json.EndDate = parseDate(json.EndDate);

  return json as LtlBidpackViewModel;
}
